define('views/modules/forum/summary/forum-summary',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/parts/info-section',
    // Templates
    'text!templates/modules/forum/summary/forum-summary.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // Views
    VInfoSection,
    // Templates
    TForumSummary
) {

    var VForumSummary = Backbone.View.extend({
        template: TForumSummary,

        regions: {
            content: ".forum-content",
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.url = this.options.url;

            var view = this.view = {
                info: new VInfoSection({
                    title: "Last forum activities",
                    content: this.template,
                    buttonTop: {
                        link: '#/' + this.url,
                        text: 'Show more activities',
                        displayIcon: false,
                    }
                }),
            };

        },

        render: function() {
            this.assign(this.view.info, this.$el)
                .generateZones();
            //  .assign(this.view.content, this.zone.$content);

            return this;
        },

    });

    return VForumSummary;
});

